import { render, staticRenderFns } from "./PostFormAttachedUser.vue?vue&type=template&id=3010fbd9&scoped=true&"
import script from "./PostFormAttachedUser.vue?vue&type=script&lang=js&"
export * from "./PostFormAttachedUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3010fbd9",
  null
  
)

export default component.exports